export default __webpack_public_path__ + "static/media/logo.c82870c7.png";